import { Route, Routes } from "react-router-dom";
import { BalanceReport } from "./list";

export default function BalanceReportRoutes() {
  return (
    <Routes>
      <Route path="/" element={<BalanceReport />} />
    </Routes>
  );
}
